module.exports = __webpack_public_path__ + "static/icon-2c7fed4e528bf6e5bd3d7c13cd54688e.png";